import { render, staticRenderFns } from "./SliderView5.vue?vue&type=template&id=797dd9ab&"
import script from "./SliderView5.vue?vue&type=script&lang=js&"
export * from "./SliderView5.vue?vue&type=script&lang=js&"
import style0 from "./SliderView5.vue?vue&type=style&index=0&id=797dd9ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports